/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { api } from "api";
import { Trans } from "react-i18next";
import { Tab, Nav } from "react-bootstrap";
import requireAuth from "components/hoc/requireAuth";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import EmployeeRoles from "components/employeeRoles/EmployeeRoles";
import PositionRoles from "components/employeeRoles/PositionRoles";
import AuthorityTrainings from "components/employeeRoles/AuthorityTrainings";

class EmployeeRolesContainer extends Component {
  state = {
    defaultTab: localStorage.getItem("roles").includes("Manager")
      ? "#tab1"
      : "#tab2",
    currentTab: localStorage.getItem("roles").includes("Manager")
      ? "#tab1"
      : "#tab2",
    isManager: localStorage.getItem("roles").includes("Manager"),
    rolesOfEmployeesResult: null,
    positionRolesResult: null,
    authorityTrainingsResult: null,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    if (this.state.isManager) this.getRolesOfEmployees();

    this.getPositionRoles();
    this.getAuthorityTrainings();
  };

  getRolesOfEmployees = () => {
    this.props.onProcessBegin();
    api
      .get(`/api/employee-role/get-roles-of-employees`)
      .then((response) => {
        this.setState({
          rolesOfEmployeesResult: response.data.data,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  getPositionRoles = () => {
    this.props.onProcessBegin();
    api
      .get(`/api/position-role/get-position-roles`)
      .then((response) => {
        this.setState({
          positionRolesResult: response.data.data,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  getAuthorityTrainings = () => {
    this.props.onProcessBegin();
    api
      .get(`/api/authority-training/get-authority-trainings`)
      .then((response) => {
        this.setState({
          authorityTrainingsResult: response.data.data,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  renderTabbedContent = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <Tab.Container
          id="nav-tab"
          defaultActiveKey={this.state.defaultTab}
          activeKey={this.state.currentTab}
        >
          <nav className="scrollNav">
            <Nav variant="tabs" role="tablist">
              {this.state.isManager && (
                <Nav.Item>
                  <Nav.Link
                    onClick={() => this.setState({ currentTab: "#tab1" })}
                    eventKey="#tab1"
                  >
                    <Trans>employeerole_ford-role-record</Trans>
                  </Nav.Link>
                </Nav.Item>
              )}

              <Nav.Item>
                <Nav.Link
                  onClick={() => this.setState({ currentTab: "#tab2" })}
                  eventKey="#tab2"
                >
                  <Trans>employeerole_role-training-table</Trans>
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  onClick={() => this.setState({ currentTab: "#tab3" })}
                  eventKey="#tab3"
                >
                  <Trans>employeerole_authority-training-table</Trans>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </nav>

          <Tab.Content>
            {this.state.isManager && (
              <Tab.Pane eventKey="#tab1">
                {this.state.rolesOfEmployeesResult && (
                  <EmployeeRoles
                    data={this.state.rolesOfEmployeesResult}
                    refresh={() => this.getRolesOfEmployees()}
                  />
                )}
              </Tab.Pane>
            )}

            <Tab.Pane eventKey="#tab2">
              {this.state.positionRolesResult && (
                <PositionRoles data={this.state.positionRolesResult} />
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="#tab3">
              {this.state.authorityTrainingsResult && (
                <AuthorityTrainings
                  data={this.state.authorityTrainingsResult}
                />
              )}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    );
  };

  render() {
    return (
      <section className="profilArea my-3">
        {this.props.spinner}
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#" style={{ verticalAlign: "middle" }}>
                    <Trans desc="Eğitim ve Gelişim">10025</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans>nav_ford-role-and-authrorize</Trans>
                </li>
              </ul>
            </div>
          </div>
          <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <div className="profilBaslik">
                <Trans>nav_ford-role-and-authrorize</Trans>
              </div>
            </div>
          </div>
          <div className="row py-4 bottomRow">{this.renderTabbedContent()}</div>
        </div>
      </section>
    );
  }
}

export default requireAuth(containsLongRunningProcess(EmployeeRolesContainer));
